import { createContext } from 'react';

export const ThemeContext = createContext({
  theme: '' as string,
  setTheme: (theme: string) => {},
});
